import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  InputGroup,
  Button,
  Breadcrumb,
  Pagination,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { get_staffs } from "../../services/staff.service";
import { useStore } from "../../store/useStore";
import converSex from "../../helpers/convertSex";
import LoadingComponent from "../../components/LoadingComponent";
import EmptyComponent from "../../components/EmptyComponent";
import ReactPaginate from "react-paginate";
import { jwtDecode } from "jwt-decode";
import { WarningSwal } from "../../helpers/alertseet";
import cutBranchNo from "../../helpers/cutBranchNo";
import addBranchNo from "../../helpers/addBranchNo";


let limitData = 50;

export default function StaffPage() {
  const navigate = useNavigate();
  // state
  const [isLoading, setIsLoading] = useState(true);
  const [staffDataList, setStaffDataList] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [totalPagination, setTotalPagination] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [totalDataList, setTotalDataList] = useState(0);

  // store
  const { token } = useStore();
  const { branchData } = useStore();

  // useEffect
  useEffect(() => {
    getData();
  }, [pagination]);

  // function
  const handleSearch = () => {
    getData();
  };
  const getData = async () => {
    try {
      setIsLoading(true);
      const decoded = jwtDecode(token);
      let findby = "?";
      findby += `skip=${(pagination - 1) * limitData}&`;
      findby += `limit=${limitData}&`;
      if (searchInput) {
        findby += `staffNo=${addBranchNo(searchInput, branchData?.branchNo)}&`;
      }

      // findby += `branchId=${decoded?.branchId}&`;

      const data = await get_staffs(findby, token);
      if (data?.error) throw new Error(data?.message);
      setTotalDataList(data?.total);
      setTotalPagination(Math.ceil(data?.total / limitData));
      if (!data?.data) throw new Error(data?.message);
      setStaffDataList(data?.data);
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="#" active>
          ຈັດການພະນັກງານ
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card
        style={{
          padding: 16,
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 100,
          width: "100%",
        }}
      >
        <h2>ຕາຕະລາງບັນຊີພະນັກງານ</h2>
        <div
          style={{
            display: "flex",
            gap: 20,
            alignItems: "flex-end",
            marginBottom: 16,
          }}
        >
          <div>
            <label>ຄົ້ນຫາ</label>
            <InputGroup style={{ maxWidth: 230 }}>
              <Form.Control
                placeholder="ປ້ອນໄອດີພະນັກງານ"
                style={{ paddingLeft: 10 }}
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              />
              <Button
                style={{ width: 40, padding: 0 }}
                onClick={() => handleSearch()}
              >
                <Icon icon="tabler:search" style={{ width: 20, height: 20 }} />
              </Button>
            </InputGroup>
          </div>
          <div style={{ flex: 1 }}></div>
          <div>
            <Button
              onClick={() => {
                navigate("/staff/create");
              }}
              size="md"
            >
              ສ້າງບັນຊີ
            </Button>
          </div>
        </div>
        {/* loading */}
        <div
          style={{
            width: "100%",
            display: isLoading ? "flex" : "none",
            justifyContent: "center",
            padding: 20,
            height: 400,
            alignItems: "center",
          }}
        >
          <LoadingComponent />
        </div>
        <div
          style={{
            width: "100%",
            display:
              staffDataList?.length === 0 && !isLoading ? "flex" : "none",
            justifyContent: "center",
            padding: 20,
            height: 400,
            alignItems: "center",
          }}
        >
          <EmptyComponent />
        </div>
        {/*  */}
        <div
          style={{
            color: "#6c757d",
            fontSize: 14,
            fontWeight: 700,
            padding: "0px 10px",
            display: !isLoading ? "block" : "none",
          }}
        >
          ທັງໝົດ {totalDataList} ລາຍການ
        </div>
        <div
          style={{
            overflow: "auto",
            display: staffDataList?.length > 0 && !isLoading ? "block" : "none",
          }}
        >
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>ເລກພະນັກງານ</th>
                <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                <th>ຕຳແໜ່ງ</th>
                <th>ເພດ</th>
                <th>ເບີໂທ</th>
                <th>ເຮືອນເລກທີ</th>
                <th>ເມືອງ</th>
                <th>ແຂວງ</th>
              </tr>
            </thead>
            <tbody>
              {staffDataList?.map((e, i) => (
                <tr
                  onClick={() => navigate("/staff/detail/" + e?._id)}
                  key={i}
                  className="hover"
                >
                  <td>{e?.staffNo ? cutBranchNo(e?.staffNo) : "-"}</td>
                  <td>{(e?.firstName || "-") + " " + (e?.lastName || "-")}</td>
                  <td>{e?.role || "-"}</td>
                  <td>{e?.gender ? converSex(e?.gender) : "-"}</td>
                  <td>{e?.phone || "-"}</td>
                  <td>{e?.homeNumber || "-"}</td>
                  <td>{e?.district || "-"}</td>
                  <td>{e?.province || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            width: "100%",
            bottom: 20,
          }}
        >
          <ReactPaginate
            previousLabel={
              <span className="glyphicon glyphicon-chevron-left">{`<`}</span>
            }
            nextLabel={
              <span className="glyphicon glyphicon-chevron-right">{`>`}</span>
            }
            breakLabel={<Pagination.Item disabled>...</Pagination.Item>}
            breakClassName={"break-me"}
            pageCount={totalPagination} // Replace with the actual number of pages
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={(e) => {
              console.log(e);
              setPagination(e?.selected + 1);
            }}
            containerClassName={"pagination justify-content-center"} // Bootstrap class for centering
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
          />
        </div>
      </Card>
    </div>
  );
}
